<template>
    <div>
        <h1 class="display-heading mb-3">Staff Management</h1>
        <div class="table-responsive">
            <div ref="tableSection">
                <div class="mb-3">
                    <router-link :to="{'name': 'create-clinic-staff'}" tag="button" class="btn btn-primary btn-primary-insv">Add New Staff</router-link>
                </div>
                <table ref="listTable" class="table table-hover">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Name</th>
                            <th scope="col">Username</th>
                            <!-- <th scope="col">Email</th> -->
                            <th scope="col">Role</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-show="staffList.length === 0">
                            <td :colspan="columnsCount" class="text-center font-italic">
                                {{isTableLoading ? "Loading Data": "No Data"}}
                            </td>
                        </tr>
                        <tr v-for="(staff, index) in staffList" :key="index">
                            <th scope="row">{{((pagination.currentPage - 1) * pagination.pageSize ) + index + 1}}</th>
                            <td>{{staff.name}}</td>
                            <td>{{staff.username}}</td>
                            <!-- <td>{{staff.email}}</td> -->
                            <td>{{staff.role}}</td>
                            <td>
                                <router-link
                                    :to="{
                                        'name': 'edit-clinic-staff',
                                        'params': {'id': staff.clinicStaffId}
                                    }"
                                >
                                    Edit
                                </router-link>
                                <span class="delete-btn" @click="deleteStaff(staff)">Remove</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <pagination v-model="pagination.currentPage"
                :totalPages="pagination.totalPages"
                :scrollPosition="pagination.scrollPosition">
            </pagination>
        </div>
        <popup-modal ref="confirmationPopUp" :hasCloseButton="false" :title="`Remove Staff`">
            <template slot="content">
                <p v-if="!deleting">{{`Are you sure you want to remove staff ${staffToDelete.name}?`}}</p>
                <p v-else>{{`Removing...`}}</p>
            </template>
            <template slot="footer">
                <button @click="$refs.confirmationPopUp.hide()" class="btn btn-danger btn-primary-insv">No</button>
                <button @click="deleteStaffApi(staffToDelete.clinicStaffId)" class="btn btn-primary btn-primary-insv">Yes</button>
            </template>
        </popup-modal>
    </div>
</template>

<script>
import pagination from '@/components/pagination';
import popupModal from '@/components/popup-modal';

export default {
    'components': {
        pagination,
        popupModal
    },
    data () {
        return {
            'columnsCount': 1,
            'isTableLoading': true,
            'pagination': {
                'currentPage': 1,
                'totalPages': 0,
                'pageSize': 20,
                'scrollPosition': 0
            },
            'staffList': [],
            'deleting': false,
            'staffToDelete': {
                'name': '',
                'clinicStaffId': ''
            }
        };
    },
    'computed': {
        currentPage () {
            return this.pagination.currentPage;
        }
    },
    'watch': {
        currentPage () {
            this.$nextTick(() => {
                this.getClinicStaffs();
            });
        }
    },
    mounted () {
        this.columnsCount = this.$refs.listTable.rows[0].cells.length;

        // initialize scroll position
        this.$nextTick(() => {
            this.pagination.scrollPosition = this.$refs.tableSection.getBoundingClientRect().top + window.scrollY - document.querySelector('.top-navigation').clientHeight;
        });

        this.getClinicStaffs();
    },
    'methods': {
        getClinicStaffs () {
            this.axios.post('Clinic/GetStaffList', {
                'p': this.pagination.currentPage,
                'ps': this.pagination.pageSize
            }).then(({ data }) => {
                this.isTableLoading = false;
                let pagedResult = data.data;

                this.pagination.currentPage = pagedResult.p;
                this.pagination.totalPages = pagedResult.c;

                let list = pagedResult.l;

                this.staffList = list.map((staff) => ({
                    'name': staff.n ? staff.n : '-',
                    'email': staff.e ? staff.e : '-',
                    'username': staff.u ? staff.u : '-',
                    'role': staff.r === 0 ? 'Doctor' : 'Nurse',
                    'clinicStaffId': staff.csid
                }));
            });
        },
        deleteStaff (staff) {
            this.staffToDelete = staff;
            this.$refs.confirmationPopUp.show();
        },
        deleteStaffApi (clinicStaffId) {
            this.deleting = true;
            this.axios.delete(`Clinic/DeleteStaff/${clinicStaffId}`)
                .then(() => {
                    this.$refs.confirmationPopUp.hide();
                    this.deleting = false;
                    this.getClinicStaffs();
                });
        }
    }
};
</script>

<style>
    .delete-btn {
        margin-left: 10px;
        color: red;
    }
    .delete-btn:hover {
        cursor: pointer;
        text-decoration: underline;
    }
</style>
